/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** UpdateAuthResetRequest — dark-roast DTO: AuthResetTokenPatchDto */
export const updateAuthResetRequestSchema = z.object({ "mfaCode": z.string().nullish(), "password": z.string().min(1) });
export type UpdateAuthResetRequest = z.infer<typeof updateAuthResetRequestSchema>;
